import React from 'react';
import { Link } from 'react-router-dom';
import { KTIcon, enumPolicies } from '../../../../../_metronic/helpers';
import PolicyChecker from '../../../../../_metronic/helpers/components/PolicyChecker';

const ProductListTable = ({ data, intl, sorting, onChangeSorting, onStatusChange, onClone }) => {

    const renderProductImage = (item) => {
        if (item && item.imageLink) {
            return (
                <div className="symbol symbol-square symbol-75px">
                    <img src={item.imageLink} alt={item.name} className="h-50" />
                </div>
            )
        }

        return (
            <div className="symbol symbol-square symbol-75px">
                <KTIcon iconName='parcel-tracking' className='fs-5x' />
            </div>
        )
    }

    const renderProductActions = (item) => {
        if (item && item.id && item.isActive) {
            return (
                <td>
                    <button className='btn btn-light btn-active-light-primary btn-sm ' data-kt-menu-trigger="click" data-kt-menu-placement='bottom-end'> {intl.formatMessage({ id: 'PRODUCT.ACTIONS' })}
                        <KTIcon iconName='down' className='fs-5 m-0' />
                    </button>
                    <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4' data-kt-menu='true'>
                        <div className='menu-item px-3'>
                            <Link to={`/catalog-management/products/${item.id}`} className='menu-link px-3'> {intl.formatMessage({ id: 'PRODUCT.ACTIONS.EDIT' })} </Link>
                        </div>
                        <div className='menu-item px-3'>
                            {
                                item.isActive ?
                                    <span className='menu-link px-3 cursor-pointer' onClick={() => onStatusChange(item.id, false)}> {intl.formatMessage({ id: 'PRODUCT.ACTIONS.DEACTIVE' })} </span> :
                                    <span className='menu-link px-3 cursor-pointer' onClick={() => onStatusChange(item.id, true)}> {intl.formatMessage({ id: 'PRODUCT.ACTIONS.ACTIVE' })} </span>
                            }
    
                        </div>
                        <div className='menu-item px-3'>
                            <span className='menu-link px-3 cursor-pointer' onClick={() => onClone(item.id)}> {intl.formatMessage({ id: 'PRODUCT.ACTIONS.CLONE' })} </span>
                        </div>
                    </div>
                </td>
            )
        }
    }

    return (
        <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
                <tr className="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
                    <th>#</th>
                    <th>{intl.formatMessage({ id: 'PRODUCT.IMAGE' })}</th>
                    <th className={`cursor-pointer ${sorting["name"]}`} onClick={() => onChangeSorting("name")}>{intl.formatMessage({ id: 'PRODUCT.NAME' })}</th>
                    <th className={`cursor-pointer ${sorting["sku"]}`} onClick={() => onChangeSorting("sku")}>{intl.formatMessage({ id: 'PRODUCT.SKU' })}</th>
                    <th>{intl.formatMessage({ id: 'PRODUCT.FIELD.WEIGHT' })}</th>
                    <th>{intl.formatMessage({ id: 'PRODUCT.OPTION' })}</th>
                    <th>{intl.formatMessage({ id: 'PRODUCT.CATEGORY' })}</th>
                    <th>{intl.formatMessage({ id: 'PRODUCT.STATUS' })}</th>
                    <PolicyChecker policies={[enumPolicies.ProductEdit, enumPolicies.ProductWrite]}>
                        <th>{intl.formatMessage({ id: 'PRODUCT.ACTIONS' })}</th>
                    </PolicyChecker>
                </tr>
            </thead>
            <tbody className='text-gray-600 fw-bold'>
                {
                    data && data.map((item, index) => {
                        return (
                            (
                                <tr key={item.id}>
                                    <td>
                                        {++index}
                                    </td>
                                    <td>
                                        {renderProductImage(item)}
                                    </td>
                                    <td>
                                        <Link to={`/catalog-management/products/${item.id}/detail`}>{item.name}</Link>
                                    </td>
                                    <td>{item.sku}</td>
                                    <td>{item.weight} {item.weightUnit}</td>
                                    <td>{item.optionValueName}</td>
                                    <td>{item.categoryName}</td>
                                    <td>{item.isActive ? <div className="badge badge-light-success fw-bolder">{intl.formatMessage({ id: 'PRODUCT.ACTIVE.ENABLED' })}</div> : <div className="badge badge-light-danger">{intl.formatMessage({ id: 'PRODUCT.ACTIVE.LOCKED' })}</div>}</td>
                                    <PolicyChecker policies={[enumPolicies.ProductEdit, enumPolicies.ProductWrite]}>
                                        {renderProductActions(item)}
                                    </PolicyChecker>
                                </tr>
                            )
                        )
                    })
                }
            </tbody>
        </table>
    );
};

export default ProductListTable;
